import { DetailSection, PersonCard } from 'components/Find/detail';
import type { FindGameOrganizer } from 'components/Find/types';

interface Props {
  organizer: FindGameOrganizer;
  /**
   * `lg` (default) is Figma's "Modal M" row: a 64px avatar with the button beside
   * the name. `md` is the plain row, where the button sits at the right edge —
   * what the listing preview's narrower column uses.
   */
  sizeDesktop?: 'lg' | 'md';
}

export default function MatchOrganizer({ organizer, sizeDesktop = 'lg' }: Props) {
  return (
    <DetailSection title="Organizer" sizeDesktop="lg">
      <PersonCard {...organizer} sizeDesktop={sizeDesktop === 'lg' ? 'lg' : undefined} />
    </DetailSection>
  );
}
